var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Filters',[_c('div',[_c('FilterDropdown',{attrs:{"label":"Date Period","options":_vm.dateOptions}})],1),_c('div',[_c('FilterDropdown',{attrs:{"label":"Username","options":_vm.usernameOptions}})],1),_c('div',[_c('FilterDropdown',{attrs:{"label":"Menu","options":_vm.menuOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }